import * as Yup from "yup";

import { DEVICE_APP_KEY_LENGTH, DEVICE_EUI_LENGTH } from "entities/devices";

const HEX_REGEX = /^[0-9A-Fa-f]+$/;

export const buildValidationSchema = (isCreate: boolean, isAdmin: boolean) =>
  Yup.object({
    companyId: isAdmin
      ? Yup.string().trim().required("Please choose an option.")
      : Yup.string(),
    portfolioId: Yup.string().trim().required("Please choose an option."),
    assetId: Yup.string().trim().required("Please choose an option."),
    installationLocation: Yup.string().trim().max(100, "Maximum 100 characters."),
    deviceProfileKey: isCreate
      ? Yup.string().required("Please choose an option.")
      : Yup.string(),
    devEui: isCreate
      ? Yup.string()
          .trim()
          .required("Please fill out this field.")
          .length(DEVICE_EUI_LENGTH, `Device EUI must be exactly ${DEVICE_EUI_LENGTH} hex characters.`)
          .matches(HEX_REGEX, "Only hexadecimal characters (0-9, A-F) are allowed.")
      : Yup.string(),
    appKey: isCreate
      ? Yup.string()
          .trim()
          .transform((value) =>
            typeof value === "string" ? value.replace(/-/g, "") : value,
          )
          .required("Please fill out this field.")
          .length(DEVICE_APP_KEY_LENGTH, `AppKey must be exactly ${DEVICE_APP_KEY_LENGTH} hex characters.`)
          .matches(HEX_REGEX, "Only hexadecimal characters (0-9, A-F) are allowed.")
      : Yup.string(),
    reportingInterval: Yup.string().required("Please choose an option."),
    calibrationInterval: Yup.string().required("Please choose an option."),
    // Calibration date and certificate are only collected at registration time.
    lastCalibrationDate: isCreate
      ? Yup.string().required("Please select the date of last calibration.")
      : Yup.string(),
  });
